import type { TextContentBlock } from '../../utils/content-block-schema'
import type { ContentBlocksAndAdSlotMarkers } from '../types/content-block-types'
import type { NewContentBlock } from '../stores/content-block-store'

const isTextBlock = (block: NewContentBlock<ContentBlocksAndAdSlotMarkers>): block is NewContentBlock<TextContentBlock> => {
  return block.type === 'text' && 'text' in block.data
}

// TODO: Remove when fixed in CMS @see https://bauer-specialist.atlassian.net/browse/TCDW-483
export function splitTextBlocks (blocks: NewContentBlock<ContentBlocksAndAdSlotMarkers>[]): NewContentBlock<ContentBlocksAndAdSlotMarkers>[] {
  return blocks.reduce<NewContentBlock<ContentBlocksAndAdSlotMarkers>[]>((acc, block) => {
    if (!isTextBlock(block)) {
      acc.push(block)
      return acc
    }

    // Split content into top-level elements
    const elements = block.data.text
    // Match complete elements: h2, h3, p, ul, ol with their content
      .match(/<(h[23]|p|ul|ol)[^>]*>[\s\S]*?<\/\1>|(<p[^>]*>(\s|&nbsp;)*<\/p>)/g)
      ?.filter((element) => !element.match(/<p[^>]*>(\s|&nbsp;)*<\/p>/)) || []

    if (elements.length <= 1) {
      acc.push(block)
      return acc
    }

    // Create new blocks for each element
    const newBlocks = elements.map((element, index): NewContentBlock<ContentBlocksAndAdSlotMarkers> => ({
      ...block,
      data: {
        paragraphType: 'text',
        text: element.trim()
      },
      // We create a new block so we need to generate a new id
      id: `split-text-${block.id}-${index}`
    }))

    acc.push(...newBlocks)
    return acc
  }, [])
}
